export default __webpack_public_path__ + "static/cppglass-icon-b579f416778d46775ead134f3ed9b666.png";